// General
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  supportFormObj: {
    title: "",
    placeholder: "",
    level: 0,
    options: [],
  },
  selectedPath: [],

  reportDialogObj: {
    userId: null,
  },
};

export const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {
    updateSupportFormObj: (state, action) => {
      state.supportFormObj = action.payload;
    },
    resetSupportFormObj: (state) => {
      state.supportFormObj = initialState.supportFormObj;
    },
    updateSelectedPath: (state, action) => {
      state.selectedPath = action.payload;
    },

    updateReportDialogObj: (state, action) => {
      state.reportDialogObj = action.payload;
    },
    resetReportDialogObj: (state) => {
      state.reportDialogObj = initialState.reportDialogObj;
    },

    // Utility Functions
    resetSupportStore: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateSupportFormObj,
  resetSupportFormObj,
  updateSelectedPath,

  updateReportDialogObj,
  resetReportDialogObj,

  // Utility Functions
  resetSupportStore,
} = supportSlice.actions;

export default supportSlice.reducer;
